import DocLink from "components/Links/DocLink";
import * as React from 'react';
export default {
  DocLink,
  React
};